<template>
  <div class="animated fadeIn">
    <div v-if="$route.name == 'Users'" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" /> Users
            <router-link :to="'/admin/users/new'" class="pull-right btn btn-success btn-sm" exact>
              New
            </router-link>
          </div>
          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by person title"
            >
          </div>
          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
            <div class="table-responsive">
              <table v-if="total" class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Roles</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in entities" :key="item.id" :data-id="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.roles.map(item => item.name).join(', ') }}</td>
                    <td class="table-list__cell--narrow">
                      <button
                        v-if="item.google2fa_enabled && activeUser.id !== item.id"
                        class="btn btn-primary btn-sm"
                        @click="disable2fa(item.id)"
                      >
                        Disable2FA
                        <span :ref="`activeBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                      <button
                        v-if="item.active && activeUser.id !== item.id"
                        class="btn btn-primary btn-sm"
                        @click="deactivateUser(item.id)"
                      >
                        Block
                        <span :ref="`activeBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                      <button
                        v-if="!item.active && activeUser.id !== item.id"
                        class="btn btn-primary btn-sm"
                        @click="activateUser(item.id)"
                      >
                        Activate
                        <span :ref="`activeBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                      <router-link
                        class="btn btn-primary btn-sm"
                        :to="{ name: 'UsersEdit', params: { id: item.id }}"
                      >
                        Edit
                      </router-link>
                      <button
                        v-if="activeUser.id !== item.id"
                        class="btn btn-danger btn-sm"
                        @click="$_deleteEntity(item, 'users/', 'User')"
                      >
                        Delete <span :ref="`deleteBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="total === 0">There are no entities for your request</div>
            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
// Mixins
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'UsersList',

  components: {
    pager: Pager,
  },

  mixins: [ListPageMixin, CommonPageMixin],

  computed: {
    activeUser() {
      return this.$store.state.user.info;
    },
  },

  mounted() {
    this.getRoles();
  },

  methods: {
    disable2fa(userId) {
      if (window.confirm(`Do you really want to disable Google 2FA for user with id = ${userId}?`)) {
        const loader = this.$refs[`activeBtnLoader_${userId}`][0];
        loader.style.display = 'inline-block';

        this.$apiHttp.post(`${this.$config.app_api.prefix}users/disable2fa/${userId}`)
          .then(() => {
            const userIndex = _.findIndex(this.entities, user => user.id === userId);
            this.entities[userIndex].google2fa_enabled = false;
          })
          .catch((error) => { console.error(error); })
          .finally(() => { loader.style.display = 'none'; });
      }
    },
    activateUser(userId) {
      if (window.confirm(`Do you really want to activate user with id = ${userId}?`)) {
        const loader = this.$refs[`activeBtnLoader_${userId}`][0];
        loader.style.display = 'inline-block';

        this.$apiHttp.post(`${this.$config.app_api.prefix}users/activate/${userId}`)
          .then(() => {
            const userIndex = _.findIndex(this.entities, user => user.id === userId);
            this.entities[userIndex].active = true;
          })
          .catch((error) => { console.error(error); })
          .finally(() => { loader.style.display = 'none'; });
      }
    },
    deactivateUser(userId) {
      if (window.confirm(`Do you really want to block user with id = ${userId}?`)) {
        const loader = this.$refs[`activeBtnLoader_${userId}`][0];
        loader.style.display = 'inline-block';

        this.$apiHttp.post(`${this.$config.app_api.prefix}users/block/${userId}`)
          .then(() => {
            const userIndex = _.findIndex(this.entities, user => user.id === userId);
            this.entities[userIndex].active = false;
          })
          .catch((error) => { console.error(error); })
          .finally(() => { loader.style.display = 'none'; });
      }
    },
    getRoles() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}roles`)
        .then((response) => {
          const rolesArr = _.cloneDeep(response.data);
          delete rolesArr.meta;
          this.$store.commit('roles/setRolesList', _.toArray(rolesArr));
        }).catch((error) => {
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting roles request' });
          console.error(error);
        });
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}users?search_string=${searchString}&page=${page}&with[]=roles`)
        .then((response) => {
          if (this.searchProcessId === searchProcessId) {
            if (this.$refs.spinner) { this.$refs.spinner.hide(); }
            this.total = response.data.meta.pagination.total;
            this.perPage = response.data.meta.pagination.per_page;

            const usersArr = _.cloneDeep(response.data);
            delete usersArr.meta;
            this.entities = _.toArray(usersArr);
          }
        }).catch((error) => { this.$_errorCallback(error); });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?f4170592